import { render, staticRenderFns } from "./CompanyTable.vue?vue&type=template&id=15fda585&scoped=true"
import script from "./CompanyTable.vue?vue&type=script&lang=js"
export * from "./CompanyTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyTable.vue?vue&type=style&index=0&id=15fda585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fda585",
  null
  
)

export default component.exports